import { InMemoryStorage } from './strategies';
var KVStore = /** @class */ (function () {
    function KVStore(stores) {
        var availableStore = stores.find(function (store) { return store.isAvailable(); });
        if (!availableStore) {
            var failedStores = stores.map(function (store) { return store.getName(); }).join(', ');
            console.warn("KVStore: no available storage options(tried ".concat(failedStores, "). Using in-memory storage."));
            availableStore = new InMemoryStorage();
        }
        this.store = availableStore;
    }
    KVStore.prototype.setItem = function (key, value) {
        this.store.setItem(key, value);
    };
    KVStore.prototype.getItem = function (key) {
        return this.store.getItem(key);
    };
    KVStore.prototype.removeItem = function (key) {
        this.store.removeItem(key);
    };
    KVStore.prototype.clear = function () {
        this.store.clear();
    };
    KVStore.prototype.hasItem = function (key) {
        return this.store.hasItem(key);
    };
    return KVStore;
}());
export { KVStore };
